<template>
  <li class="job-share-item">
    <div
      class="d-block d-md-flex text-center text-md-left flex-column justify-center align-md-center"
    >
      <a
        :href="localize(value.url)"
        target="_blank"
        :aria-label="value.altText"
      >
        <v-icon
          v-if="!hasCustomSocialMediaIcons || value.customIconName === ''"
          :style="`--xingLogoUrl: ${xingLogoUrl}`"
          :aria-hidden="false"
        >
          {{ value.icon }}
        </v-icon>
        <img
          v-else
          :src="`${apiUrl}/file/public?slug=${slug}&fileName=${value.customIconName}`"
          :alt="value.altText"
        />
      </a>
    </div>
  </li>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    value: {
      type: Object,
      required: true
    },

    hasCustomSocialMediaIcons: {
      type: Boolean,
      required: false,
      default: false
    },

    slug: {
      type: String,
      required: true
    }
  },

  computed: {
    ...mapGetters('companyModule', {
      apiUrl: 'currentCompanyApiUrl'
    }),

    xingLogoUrl() {
      return `url(${this.apiUrl}/file/public?slug=common&fileName=xing.png)`;
    }
  }
};
</script>
<style scoped>
i.v-icon.mdi-xing {
  max-height: 24px;
  align-items: baseline;
}

i.v-icon.mdi-xing::before {
  content: var(--xingLogoUrl);
}
</style>
